/* DSL Cart-merge — sync cart-snapshot naar customer.metafields.dsl.cart bij login */
(function(){
  if (!window.DSL_CUSTOMER || !window.DSL_CUSTOMER.id) return;
  var ENDPOINT = (window.DSL_CONFIG && window.DSL_CONFIG.cartSyncEndpoint) || "/apps/dsl/cart-sync";
  document.addEventListener("dsl:cart:change", function(){
    fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
      fetch(ENDPOINT, {method:"POST", credentials:"same-origin", headers:{"Content-Type":"application/json"}, body: JSON.stringify({customer_id: window.DSL_CUSTOMER.id, cart: c})}).catch(function(){});
    });
  });
  // On load: try to fetch saved cart
  fetch(ENDPOINT + "?customer_id=" + window.DSL_CUSTOMER.id).then(function(r){return r.json();}).then(function(d){
    if (!d || !d.items || !d.items.length) return;
    fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
      if (c.item_count > 0) return; // local cart wins
      var items = d.items.map(function(i){return {id: i.variant_id, quantity: i.quantity};});
      fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({items: items})}).then(function(){
        if (window.DSL_BANNER) window.DSL_BANNER.show({text: "We hebben je winkelwagen van een ander apparaat hersteld!", variant: "success"});
      });
    });
  }).catch(function(){});
})();